















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import Query from '../../../components/query/index.vue'
import print from '../../../components/print/bill.vue'
import myTable from '../../../components/table/my-table.vue'
import {GetCreditDetail, GetPrePaymentBalance} from "../../../api/statistics"

@Component({
  components:{Query,myTable,print}
})
export default class extends AbpBase{
    printShow = false

    columns:any = [
        {
            title: '日期',
            key: 'date'
        },
        {
            title: '透析号',
            key: 'dialysisNum'
        },
        {
            title: '患者姓名',
            key: 'patientName'
        },
        {
            title: '身份证号',
            key: 'identityCard'
        },
        {
            title: '操作类型',
            key: 'otpType',
            filters: [
                {
                    text: '挂账明细',
                    value: 1
                },
                {
                    text: '还款明细',
                    value: 2
                }
            ],
            filterMethod :(value:any, row:any) => {
                if (value === 1) {
                    return row.otpType === "挂账" || row.otpType === "退费冲账";
                } else if (value === 2) {
                    return row.otpType === "还款";
                }
            }
        },
        {
            title: '金额',
            key: 'amount',
            render:(h:any,p:any)=>{
                return h('span', p.row.otpType === '退费冲账' ? 0 - p.row.amount : p.row.amount)
            }
        },
        {
            title: '操作员',
            key: 'operator'
        }
    ]
    date = []
    list = []
    tenantId = null
    tenantList = []
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.date = [start, end];
        this.getSelect()    
        this.getData()
    }
    async getSelect(){
        this.tenantList = (await this.QueryTenant({queryString:'',pageSize:10000,page:1}) as any).data
    }
    gzSum = 0
    hkSum = 0
    async getData(){
        let data = {
            startDate: this.date[0],
            endDate: this.date[1],
            tenantId:this.tenantId
        }
        if(!this.tenantId) delete data.tenantId;
        let res = await GetCreditDetail(data)
        if (res.data.length) {
            this.gzSum = 0
            this.hkSum = 0
            res.data.forEach((item:any)=>{
                if (item.otpType === "挂账") {
                    this.gzSum = this.gzSum + Number(item.amount) * 10000
                } else if (item.otpType === "退费冲账"){
                    this.gzSum = this.gzSum - Number(item.amount) * 10000
                } else if (item.otpType === "还款"){
                    this.hkSum = this.hkSum + Number(item.amount) * 10000
                }
            })

        }
        this.list = res.data;
    }

    downxlsx(){
        let XLSX = this.$XLSX;
        var xlsxParam = { raw: true };//转换成excel时，使用原始的格式
        var wb = XLSX.utils.table_to_book(document.querySelector("#mytable"),xlsxParam);//mytable为表格的id名
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
        });
        try {
            this.$FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            this.$route.meta.title+".xlsx"
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    }
}
